module.exports = __webpack_public_path__ + "static/solar-1566ad874dda1d384db0ee27a03888aa.png";